module.exports = __webpack_public_path__ + "img/Desk Stationeryd16.9ed53fa0.jpg";